document.addEventListener("DOMContentLoaded", async function () {
  //
  // handleStickySummary
  //

  function handleStickySummary() {
    const swatchesBlock = document.getElementById("swatchesBlock");
    let priceTiers = [];

    swatchesBlock.addEventListener("click", loadPriceTiersOnce, { once: true });
    swatchesBlock.addEventListener("click", handleQuantityChange);
    
/*

    // Versione con quantity breaks old

    function loadPriceTiersOnce() {
      const omgOfferWrapper = document.querySelector(".omg-offer-wrapper");
      if (omgOfferWrapper) {
        omgOfferWrapper.querySelectorAll("tr").forEach((row) => {
          const quantityText = row.cells[0]?.textContent.trim();
          const priceText = row.cells[1]?.textContent.trim();
          const minQuantity = parseInt(quantityText.match(/\d+/)?.[0] || 0);
          const price = parseFloat(
            priceText.match(/€(\d+,\d+)/)?.[1].replace(",", ".") || 0
          );
          if (price > 0) priceTiers.push({ minQuantity, price: price * 100 });
        });
      }
    }
*/

    function loadPriceTiersOnce() {
      const tableBody = document.querySelector(".lb-vd-table-body");
      
      // Rimuovi la dichiarazione locale di priceTiers per aggiornare l'array globale
      if (tableBody) {
        tableBody.querySelectorAll(".lb-vd-table-body-row").forEach((row) => {
          const quantityText = row.querySelector(".lb-vd-table-body-text").textContent.trim();
          const priceText = row.querySelector(".money").textContent.trim();
    
          // Estrae il numero minimo dalla stringa "Buy 12 - 23" o "Buy 60+"
          const minQuantityMatch = quantityText.match(/Buy (\d+)/);
          const minQuantity = minQuantityMatch ? parseInt(minQuantityMatch[1]) : 0;
    
          // Estrae il prezzo in formato numerico, sostituendo la virgola con il punto
          const priceMatch = priceText.match(/€(\d+,\d+)/);
          const price = priceMatch ? parseFloat(priceMatch[1].replace(",", ".")) : 0;
    
          // Se il prezzo è valido, lo aggiunge all'array priceTiers moltiplicato per 100 (centesimi)
          if (price > 0) {
            priceTiers.push({ minQuantity, price: price * 100 });
          }
        });
    
        console.log("Prezzi letti:", priceTiers);
      }
    }
    
    function handleQuantityChange(event) {
      if (event.target.classList.contains("qty-input__btn")) {
        setTimeout(() => updateStickySummary(event), 0);
      }
    }

    function updateStickySummary(event) {
      const stickySummaryVariants = swatchesBlock.querySelector(
        ".sticky-summary--variants"
      );
      const color = event.target.closest(".variant-color");

      if (!color) return;

      const quantityElem = color.querySelector(".variant-quantity");
      //const skuElem = color.querySelector(".variant-info__sku");
      //const variantIdElem = color.querySelector(".variant-quantity");
      const variantId = quantityElem ? quantityElem.getAttribute("data-variant-id") : null;
      const quantity = parseInt(quantityElem.value);
      //const sku = skuElem ? skuElem.textContent.trim() : null;

      const existingVariant = stickySummaryVariants.querySelector(
        `[data-variant-id="${variantId}"]`
      );

      if (variantId) {
        if (quantity > 0) {
          if (existingVariant) {
            existingVariant.remove();
          }
          addVariantToSummary(stickySummaryVariants, color, quantity, variantId);
        } else if (existingVariant) {
          existingVariant.remove();
        }
      }

      let totalQuantity = 0;
      let totalPrice = 0;

      swatchesBlock.querySelectorAll(".variant-color").forEach((color) => {
        const quantity = color.querySelector(".variant-quantity");
        if (quantity && parseInt(quantity.value) > 0) {
          totalQuantity += parseInt(quantity.value);
          totalPrice +=
            parseInt(quantity.getAttribute("data-variant-price")) *
            parseInt(quantity.value);
        }
      });

      const adjustedUnitPrice = getUnitPriceForQuantity(totalQuantity);
      if (adjustedUnitPrice !== null)
        totalPrice = adjustedUnitPrice * totalQuantity;

      displaySummary(totalQuantity, totalPrice);
    }

    function addVariantToSummary(container, color, quantity, variantId) {
      const newDiv = document.createElement("div");
      newDiv.textContent = quantity;
      newDiv.setAttribute("style", color.getAttribute("style"));
      newDiv.setAttribute("data-variant-id", variantId);
      newDiv.classList.add(
        color.classList.contains("color-chip--dark")
          ? "color-chip--dark"
          : "color-chip--lite"
      );
      container.prepend(newDiv);
    }

    function getUnitPriceForQuantity(totalQuantity) {
      let unitPrice = null;
      priceTiers.forEach((tier) => {
        if (totalQuantity >= tier.minQuantity) unitPrice = tier.price;
      });
      return unitPrice;
    }

    function displaySummary(totalQuantity, totalPrice) {
      swatchesBlock.querySelector(".sticky-summary--total ins").textContent =
        totalQuantity;
      swatchesBlock.querySelector(
        ".sticky-summary--price ins"
      ).textContent = `${(totalPrice / 100).toFixed(2).replace(".", ",")}`;
      swatchesBlock
        .querySelector(".sticky-summary")
        .classList.toggle("is-hidden", totalQuantity === 0);
    }
  }

  handleStickySummary();

  //
  // handleAddToCart
  //

  function handleAddToCart() {
    const swatchesBlock = document.getElementById("swatchesBlock");
    const button = swatchesBlock.querySelector("button.add-to-cart-button");
    const variants = swatchesBlock.querySelectorAll("input.variant-quantity");

    button.addEventListener("click", async function () {
      const itemsToAdd = [];

      variants.forEach((variant) => {
        const variantId = variant.getAttribute("data-variant-id");
        const variantQty = parseInt(variant.value);

        if (variantQty > 0) {
          itemsToAdd.push({ id: variantId, quantity: variantQty });
        }
      });

      if (itemsToAdd.length > 0) {
        button.classList.add("is-loading");
        await addToCart(itemsToAdd);
        button.classList.add("is-loading");
        await updateCartDrawer();
        button.classList.remove("is-loading", "is-success");
      } else {
        console.log("Nessun articolo da aggiungere al carrello");
      }
    });

    async function addToCart(items) {
      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: items }),
        });

        if (!response.ok) throw new Error("Errore aggiungendo al carrello");
        return await response.json();
      } catch (error) {
        console.error("Errore:", error);
      }
    }

    async function updateCartDrawer() {
      const cartDrawerComponent = document.querySelector("cart-drawer");

      if (cartDrawerComponent) {
        document.dispatchEvent(
          new CustomEvent("dispatch:cart-drawer:refresh", {
            bubbles: true,
          })
        );

        await new Promise((resolve) => setTimeout(resolve, 500));
        await cartDrawerComponent.open();
        await resetStickySummary();
      }
    }

    async function resetStickySummary() {
      const stickySummary = swatchesBlock.querySelector(".sticky-summary");
      if (stickySummary) {
        stickySummary.classList.add("is-hidden");
      }

      variants.forEach((variant) => (variant.value = 0));

      const stickySummaryVariants = swatchesBlock.querySelector(
        ".sticky-summary--variants"
      );
      if (stickySummaryVariants) {
        stickySummaryVariants.innerHTML = "";
      }
    }
  }

  handleAddToCart();

  /*

  //
  // TRF
  //

  //color chip text auto contrast (based on W3C luminance formula)
  function textColorAutoContrast() {
    const $chips = document.querySelectorAll(
      ".color-chip:not(.color-chip--image)"
    );
    var chipClass = "color-chip--lite";
    $chips.forEach(function ($chip) {
      const rgb = String($chip.style.backgroundColor); // NB: il selettore js restituisce valore RGB, non HEX
      const $rgb = rgb
        .substring(4, rgb.length - 1)
        .replace(/ /g, "")
        .split(",");

      const r = $rgb[0];
      const g = $rgb[1];
      const b = $rgb[2];

      const srgb = [r / 255, g / 255, b / 255];
      const x = srgb.map((i) => {
        if (i <= 0.04045) {
          return i / 12.92;
        } else {
          return Math.pow((i + 0.055) / 1.055, 2.4);
        }
      });

      const L = 0.2126 * x[0] + 0.7152 * x[1] + 0.0722 * x[2];
      chipClass = L > 0.199 ? "color-chip--lite" : "color-chip--dark"; //default 0.179
      $chip.classList.add(chipClass);
    });
    return;
  }

  textColorAutoContrast();

  */
});

//
// Umbe #1
//

const stickySummary = document.querySelector(".sticky-summary");
const stickyObserver = document.querySelector(".sticky-summary--observer");

function handleScroll() {
  const observerTop =
    stickyObserver.offsetTop - window.innerHeight + stickySummary.offsetHeight;
  const scrollTop = window.scrollY || document.documentElement.scrollTop;

  if (scrollTop < observerTop) {
    stickySummary.classList.add("is-fixed");
  } else {
    stickySummary.classList.remove("is-fixed");
  }
}

window.addEventListener("scroll", handleScroll);

//
// Umbe #2
//

function updateMaxQuantities(cart) {
  const colorVariantsList = document.querySelector(".color-variants-list");
  if (!colorVariantsList) return;

  colorVariantsList
    .querySelectorAll(".variant-color")
    .forEach((variantColor) => {
      const input = variantColor.querySelector(
        ".qty-input__input.variant-quantity"
      );
      if (!input) return;

      const ogStock = parseInt(input.getAttribute("data-variant-og-stock"));
      //const cartItem = cart.items.find((item) =>
      //  item.sku.includes(input.getAttribute("data-variant-sku"))
      //);
      const variantId = input.getAttribute("data-variant-id");
      const cartItem = cart.items.find((item) => item.id == variantId);
      const newMax = cartItem ? ogStock - cartItem.quantity : ogStock;

      input.setAttribute("max", newMax);
      variantColor.classList.toggle("disabled", newMax === 0);
    });
}

function fetchCartAndUpdate() {

  if (window.isCrawlerUserAgent && window.isCrawlerUserAgent()) {
    // è un bot → skip
    return;
  }

  fetch("/cart.js", {
    headers: {
      "Accept": "application/json"
    }
  })
    .then(function (response) {
      if (!response.ok) {
        // HTTP non 2xx → errore "pulito"
        throw new Error("Risposta non OK da /cart.js: " + response.status);
      }
      return response.text();
    })
    .then(function (text) {
      if (!text) {
        // Nessun contenuto → niente da aggiornare, esco senza errori
        return;
      }

      var cart;
      try {
        cart = JSON.parse(text);
      } catch (e) {
        // Il body non è JSON valido → esco silenziosamente o con warn
        console.warn("Risposta /cart.js non in JSON valido, skip updateMaxQuantities");
        // console.warn("Contenuto:", text); // se ti serve debug, scommenta
        return;
      }

      if (!cart || !Array.isArray(cart.items)) {
        // JSON strano/incompleto → esco
        return;
      }

      updateMaxQuantities(cart);
    })
    .catch(function (error) {
      console.error("Errore nel caricamento del carrello:", error);
    });
}


document.addEventListener("DOMContentLoaded", fetchCartAndUpdate);
document.addEventListener("on:cart-drawer:after-open", fetchCartAndUpdate);
document.addEventListener("on:line-item:change", fetchCartAndUpdate);
